if (!customElements.get('vto-modal')) {
  customElements.define(
    'vto-modal',
    class VtoModal extends FetchModalDialog {
      constructor() {
        super();
        this.vto = {
          state : {
            apiKey : this.getAttribute('data-api-key'),
            versionID : this.getAttribute('data-version-id'),
            experienceType : this.getAttribute('data-vto-type'),
            hasShadeSelection: this.getAttribute('data-has-shade-selection') !== 'false',
            previousBarcode: null,
            ymkAsyncInitialized: false,
            variantBarcodes: this.getAttribute('data-variant-barcodes')
          },
          // wizard set up for bundles
          wizard: {
            isWizard: this.getAttribute('data-is-wizard') === 'true',
            handles: this.getAttribute('data-wizard-handles') ? this.getAttribute('data-wizard-handles').split(',').map(h => h.trim()) : [],
            allBundleHandles: this.getAttribute('data-all-bundle-handles') ? this.getAttribute('data-all-bundle-handles').split(',').map(h => h.trim()) : [],
            currentIndex: 0,
            selectedShades: {},
            badgesInitialized: false,
            isReloadingCamera: false,
            hasReloadedCamera: false
          },
          // multi-product VTO
          multiProduct: {
            isMultiProduct: false,
            products: [],
            currentIndex: 0,
            initialized: false,
            swiper: null,
            fromCustomKit: false,
            collectionId: null,
            selectedShades: {}
          },
          customKitSingleContext: null,
          components : {
            modalContent: this.querySelector('.vto-modal__content'),
            getStartedButton : this.querySelector('.vto-modal__get-started-button'),
            modalBackButton : this.querySelector('.vto-modal__back'),
            modalToggleButton : this.querySelector('.vto-modal__toggle'),
            allExperiences: this.querySelector('.vto-modal__all-experiences'),
            basicExperience : this.querySelector('.vto-modal__basic-experience'),
            smartExperience: this.querySelector('.vto-modal__smart-experience'),
            review: this.querySelector('.vto-modal__review'),
            legal : this.querySelector('.vto-modal__legal'),
            legalCheckBox: this.querySelector('#Vto-legal-checkbox'),
            swatches: this.querySelectorAll('.vto-modal__swatch'),
            circleSwatches: this.querySelectorAll('.vto-modal__circle-swatch'),
            removeButton: this.querySelectorAll('.vto-modal__remove-style'),
            vtoBackButton: this.querySelector('button[aria-label="go back to launcher screen"]'),
            vtoAddToBagButton: this.querySelector('.vto-modal__content #vto_modal_add_form .cta-button'),
            vtoAddToBagFormInput: this.querySelector('#vto_modal_add_form input.product-variant-id[name="id"]'),
            shadeName: this.querySelector('.vto-select-a-shade'),
            shadeInputs: this.querySelectorAll('input.vto-shade-input[type="radio"]'),
            allShadesButton: this.querySelector('#display-all-shades'),
            wizardPrevButton: this.querySelector('[data-wizard-prev]'),
            wizardNextButton: this.querySelector('[data-wizard-next]'),
            wizardFinishButton: this.querySelector('[data-wizard-finish]'),
            wizardProductImages: this.querySelectorAll('.vto-wizard__product-image'),
            multiProductImages: this.querySelector('.vto-multi-product__product-images'),
            productTitle: this.querySelector('.vto-product-title'),
            swatchContainer: this.querySelector('.vto-modal__basic-experience .swiper-wrapper')
          },
          openFromModalDialog : null,
          openFromFindaton : null,
          openerProductId : this.getAttribute('data-opener-product-id'),
          masterId: this.getAttribute('data-masterid'),
          fromBundle : this.getAttribute('data-from-bundle') === 'true' ? true : false,

        }

        this.defaultCtaText = this.vto.components.vtoAddToBagButton?.textContent?.trim() || 'ADD TO BAG';
      }

      connectedCallback() {
        this.initEventListeners();
        this.appendYouCamScript();
        this.initSwatchSwiper();
        this.waitForWindowProperty('YMK').then(lib => {
          this.initYouCamWindow();
        })
        .catch(err => {
          console.error(err);
        });
      }

      hide() {
        super.hide();

        // Clear multi-product VTO globals unless persistence was requested by opener
        const shouldPersist = window.__multiVtoMeta?.persistAfterClose === true;
        if (this.vto.multiProduct.isMultiProduct && !shouldPersist) {
          window.__multiVtoProducts = null;
          window.__multiVtoMeta = null;
        }

        this.vto.customKitSingleContext = null;
      }

      async show(opener) {
        // Detect multi-product context from opener
        this.detectMultiProductContext(opener);
        this.detectCustomKitSingleContext();

        if (opener) {
          super.show(opener);
          if (opener.tagName && opener.tagName.toUpperCase() === "FINDATION-WIDGET") {
            this.openFromFindation = opener;
          } else {
            this.openFromModalDialog = opener.closest('modal-dialog') || opener.closest('fetch-modal-dialog');
          }
        }
        if (this.openFromModalDialog || this.openFromFindation) {
          this.vto.components.modalBackButton.classList.remove('hidden');
        } else {
          this.vto.components.modalBackButton.classList.add('hidden');
        }

        // Initialize bundle wizard product image badges on first show
        if (this.vto.wizard.isWizard) {
          if (!this.vto.wizard.badgesInitialized) {
            this.initializeWizardBadges();
            this.vto.wizard.badgesInitialized = true;
          }

          await this.refreshVtoBundleAvailability({ forceFetch: true });
          this.loadWizardProductAtCurrentIndex();
        }

        // Initialize multi-product VTO on first show
        if (this.vto.multiProduct.isMultiProduct && !this.vto.multiProduct.initialized) {
          this.initializeMultiProduct();
          this.vto.multiProduct.initialized = true;
        } else if (this.vto.multiProduct.isMultiProduct && this.vto.multiProduct.initialized && this.vto.multiProduct.swiper) {
          this.vto.multiProduct.swiper.update();
          this.toggleMultiProductNavigation(this.vto.multiProduct.swiper);
        }
      }

      handleBackButtonClick() {
        if (this.openFromModalDialog) {
          this.hide();
          this.openFromModalDialog.show();
        }
        if (this.openFromFindation) {
          this.hide();
          this.openFromFindation.openWidget();
        }
      }

      handleGetStartClick() {
        this.vto.components.modalToggleButton.classList.add('hidden');
        this.vto.components.legal.classList.add('hidden');
        this.vto.components.allExperiences.classList.remove('hidden');

        if (!this.vto.state.hasShadeSelection && !this.vto.wizard.isWizard && !this.vto.multiProduct.isMultiProduct) {
          const firstSwatch = this.querySelector('.vto-modal__basic-experience .vto-modal__swatch:not([data-no-selection])');
          if (firstSwatch) {
            firstSwatch.classList.add('vto-swatch-selected');
            const variantID = firstSwatch.dataset.variantId;
            this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-id', variantID);
            this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-available', !firstSwatch.classList.contains('oos'));
            if (!this.vto.fromBundle) this.vto.components.vtoAddToBagFormInput.value = variantID;
            this.updateAddToBagButton();
            this.vto.components.vtoAddToBagButton.disabled = false;
          }
          this.vto.components.shadeName?.classList.add('hidden');
          const realSwatches = this.querySelectorAll('.vto-modal__basic-experience .vto-modal__swatch:not([data-no-selection])');
          if (realSwatches.length <= 1) {
            this.querySelector('.vto-modal__swatch-swiper-wrapper')?.classList.add('hidden');
          }
          window.YMK.open();
          return;
        }

        // Multi-product VTO always in basic experience
        if (this.vto.multiProduct.isMultiProduct) {
          this.toggleVtoExperience('Basic');
          window.YMK.open();
        } else {
          this.toggleVtoExperience(this.vto.state.experienceType);
          if (this.vto.state.experienceType === 'Smart') {
            this.openShadeFinder();
          } else {
            window.YMK.open();
          }
        }
      }

      updateAddToBagButton() {
        if (this.vto.components.vtoAddToBagButton) {
            let selectedProduct = this.vto.components.vtoAddToBagButton.getAttribute('data-selected-variant-id');
            let selectedProductAvailability = this.vto.components.vtoAddToBagButton.getAttribute('data-selected-variant-available');
            let disableATBButton = true;
            if (selectedProduct && selectedProductAvailability == 'true') {
                disableATBButton = false;
            }
            this.vto.components.vtoAddToBagButton.disabled = disableATBButton;
        }
      }

      getVtoBundleAvailabilityScope() {
        return this.querySelector('.vto-modal__all-experiences-footer .product__info-wrapper') ||
          this.querySelector('.product__info-wrapper') ||
          this;
      }

      getWizardBundleSlotForIndex(wizardIndex = this.vto.wizard.currentIndex) {
        const handle = this.vto.wizard.handles[wizardIndex];
        if (!handle) return null;

        const occurrence = this.vto.wizard.handles
          .slice(0, wizardIndex + 1)
          .filter(wizardHandle => wizardHandle === handle).length - 1;
        let seen = -1;

        for (let index = 0; index < this.vto.wizard.allBundleHandles.length; index++) {
          if (this.vto.wizard.allBundleHandles[index] !== handle) continue;
          seen += 1;
          if (seen === occurrence) return index + 1;
        }

        return wizardIndex + 1;
      }

      getBundlePickerForWizardIndex(wizardIndex = this.vto.wizard.currentIndex) {
        const slot = this.getWizardBundleSlotForIndex(wizardIndex);
        const scope = this.getVtoBundleAvailabilityScope();
        if (!slot || !scope) return null;

        return scope.querySelector(`variant-selects[data-picker-type="bundle-picker"][data-bundle-slot="${slot}"]`);
      }

      getBundleInputForVariant(variantId, wizardIndex = this.vto.wizard.currentIndex) {
        const picker = this.getBundlePickerForWizardIndex(wizardIndex);
        if (!picker || !variantId) return null;

        return Array.from(picker.querySelectorAll('input.bundle-swatch')).find(input =>
          String(input.dataset.variantId || input.getAttribute('bundle-variant-id')) === String(variantId)
        ) || null;
      }

      syncWizardSelectionToBundlePicker(wizardIndex, variantId) {
        const input = this.getBundleInputForVariant(variantId, wizardIndex);
        if (!input) return;

        const wasChecked = input.checked;
        input.checked = true;
        if (!wasChecked) {
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncWizardSelectionsToBundlePickers() {
        if (!this.vto.wizard.isWizard) return;

        Object.entries(this.vto.wizard.selectedShades).forEach(([wizardIndex, selection]) => {
          if (selection?.variantID) {
            this.syncWizardSelectionToBundlePicker(Number(wizardIndex), selection.variantID);
          }
        });
      }

      async refreshVtoBundleAvailability(options = {}) {
        if (!this.vto.fromBundle || typeof window.updateDuplicateBundleSwatchAvailability !== 'function') return;

        this.syncWizardSelectionsToBundlePickers();
        const scope = this.getVtoBundleAvailabilityScope();
        const excludeLineKey = options.excludeLineKey || (window.isFromQvCart ? window.qvCartItemKey : null);

        try {
          await window.updateDuplicateBundleSwatchAvailability(scope, {
            ...options,
            ...(excludeLineKey ? { excludeLineKey } : {})
          });
        } catch (error) {
          console.error('Unable to refresh VTO bundle inventory availability:', error);
        }
      }

      isVtoVariantSelectable(variant, wizardIndex = this.vto.wizard.currentIndex) {
        if (!variant) return false;

        if (this.vto.wizard.isWizard) {
          const bundleInput = this.getBundleInputForVariant(variant.id, wizardIndex);
          if (bundleInput) {
            return bundleInput.dataset.variantAvailable !== 'false';
          }
        }

        return variant.available !== false;
      }

      getSelectableVtoVariants(productData, wizardIndex = this.vto.wizard.currentIndex) {
        const variants = Array.isArray(productData?.variants) ? productData.variants : [];
        return variants.filter(variant => this.isVtoVariantSelectable(variant, wizardIndex));
      }

      getWizardProductData() {
        if (this.vto.wizard.productData) return this.vto.wizard.productData;

        let productData = null;
        const productDataScript = this.querySelector('script[data-wizard-product-data]');
        const productDataJson = productDataScript?.textContent?.trim();

        if (productDataJson) {
          try {
            productData = JSON.parse(productDataJson);
          } catch (error) {
            console.error('Unable to parse VTO wizard product data:', error);
            productData = {};
          }
        }

        if (!productData || typeof productData !== 'object') {
          productData = window.wizardProductData;
        }

        this.vto.wizard.productData = productData && typeof productData === 'object' ? productData : {};
        window.wizardProductData = this.vto.wizard.productData;

        return this.vto.wizard.productData;
      }

      applySelectedVariantToVto(barcode = null, isSmartResultSwatch = false) {
        const selectedBarcode = barcode || this.querySelector('.vto-modal__swatch.vto-swatch-selected')?.dataset.variantBarcode;
        if (!selectedBarcode || !window.YMK?.applyMakeupBySku) {
          return;
        }

        if (this.vto.state.previousBarcode !== selectedBarcode) {
          this.vto.state.previousBarcode = selectedBarcode;
          if (isSmartResultSwatch && this.dataset.handle) {
            const data = {
              handle: this.dataset.handle,
              barcode: selectedBarcode,
              featureID: 'vto'
            };
            document.body.dispatchEvent(new CustomEvent('shadeMatch:setData', { detail : data }));
          }
        }

        window.YMK.applyMakeupBySku(selectedBarcode);
      }

      handleSwatchClick(e) {
        const closestSwatch = e.target.closest('.vto-modal__swatch');
        if (closestSwatch) {
          // no selection swatch click events for bundle wizard setup
          const isNoSelection = closestSwatch.hasAttribute('data-no-selection');
          if (isNoSelection && this.vto.wizard.isWizard) {
            this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
            closestSwatch.classList.add('vto-swatch-selected');
            const defaultName = this.vto.components.shadeName.getAttribute('data-default-name');
            this.vto.components.shadeName.textContent = defaultName || 'Select a shade';
            delete this.vto.wizard.selectedShades[this.vto.wizard.currentIndex];
            this.resetCurrentBadgeToNoSelection();
            this.updateWizardButtonVisibility();
            this.reapplyWizardMakeup();
            return;
          }

          const barcode = closestSwatch.dataset.variantBarcode;
          const variantID = closestSwatch.dataset.variantId;
          const variantTitle = closestSwatch.dataset.variantTitle;
          const swatchImg = closestSwatch.dataset.variantSwatchImg;

          // update selected shade name
          this.vto.components.shadeName.textContent = variantTitle;
          // add selected ID to atb button
          this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-id', variantID);
          // add selected variant availability to atb button
          if (closestSwatch.classList.contains('oos')) {
            this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-available', false);
          } else {
            this.vto.components.vtoAddToBagButton.setAttribute('data-selected-variant-available', true);
          }
          // remove selected class
          this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
          // add selected class
          closestSwatch.classList.add('vto-swatch-selected');

          // Check the radio input for the clicked swatch
          const radioInput = closestSwatch.querySelector('input[type="radio"]');
          if (radioInput) {
            radioInput.checked = true;
          }

          // If this is a smart experience swatch, also check the corresponding basic experience swatch
          if (closestSwatch.classList.contains('smart-result-swatch')) {
            const basicSwatch = this.querySelector(`.vto-modal__swatch[data-variant-barcode="${barcode}"]:not(.smart-result-swatch)`);
            if (basicSwatch) {
              basicSwatch.classList.add('vto-swatch-selected');
              const basicRadioInput = basicSwatch.querySelector('input[type="radio"]');
              if (basicRadioInput) {
                basicRadioInput.checked = true;
              }
            }
          }

          // If wizard mode, save selection and update badge
          if (this.vto.wizard.isWizard) {
            this.vto.wizard.selectedShades[this.vto.wizard.currentIndex] = {
              variantTitle: variantTitle,
              swatchImg: swatchImg,
              variantID: variantID,
              barcode: barcode,
              available: !closestSwatch.classList.contains('oos')
            };
            this.updateWizardBadge(this.vto.wizard.currentIndex, swatchImg, variantTitle);
            // Enable Next/Finish button now that a selection is made
            this.updateWizardButtonVisibility();
          }

          // If multi-product mode, save selection for persistence when switching products
          if (this.vto.multiProduct.isMultiProduct) {
            const currentProduct = this.vto.multiProduct.products[this.vto.multiProduct.currentIndex];
            if (currentProduct) {
              // Find variant to get its featured image
              const variant = currentProduct.variants.find(v => String(v.id) === String(variantID));
              const variantImage = variant?.featured_image || currentProduct.featured_image;

              this.vto.multiProduct.selectedShades[currentProduct.id] = {
                variantId: variantID,
                variantTitle: variantTitle,
                swatchImg: swatchImg,
                barcode: barcode,
                variantImage: variantImage
              };

              // Update the product image in the carousel
              this.updateMultiProductCarouselImage(currentProduct.id, variantImage);
            }
          }

          if (this.vto.state.previousBarcode !== barcode) {
            window.YMK.applyMakeupBySku(barcode);
            this.vto.state.previousBarcode = barcode;
               // only for smart experience, update shade-match local storage
               if(closestSwatch.classList.contains('smart-result-swatch') && barcode && this.dataset.handle) {
                const data = {
                  handle: this.dataset.handle,
                  barcode: barcode,
                  featureID: 'vto'
                };
                document.body.dispatchEvent(new CustomEvent('shadeMatch:setData', { detail : data }));
              }
          } else {
            window.YMK.applyMakeupBySku(barcode);
          }

          if (this.vto.fromBundle) {
            // handle the possible vto modal on bundle pdp/qv when only 1 product is vto
            // find opener swatch, use the vto modal opener product id for main product id
            if (this.vto.wizard.isWizard) {
              this.syncWizardSelectionToBundlePicker(this.vto.wizard.currentIndex, variantID);
            } else {
              const variantSelects = this.querySelectorAll(`variant-selects[data-picker-type="bundle-picker"][data-product-id="${this.vto.masterId}"]`);
              if (variantSelects.length) {
                variantSelects.forEach(variantSelect => {
                  const matchingInput = Array.from(variantSelect.querySelectorAll('input[data-variant-id]'))
                    .find(input => String(input.dataset.variantId) === String(variantID));
                  matchingInput?.click();
                });
              }
            }
          } else {
            // update add to bag form with variant ID
            this.vto.components.vtoAddToBagFormInput.value = variantID;
          }
        }
        this.updateAddToBagButton();
      }

      getSelectedVariantId() {
        const buttonValue = this.vto.components.vtoAddToBagButton?.getAttribute('data-selected-variant-id');
        if (buttonValue) {
          return Number(buttonValue);
        }
        const formValue = this.vto.components.vtoAddToBagFormInput?.value;
        return formValue ? Number(formValue) : null;
      }

      handleAddToBagClick(e) {
        if (this.vto.multiProduct.isMultiProduct && this.vto.multiProduct.fromCustomKit) {
          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }
          this.handleAddToKitClick();
          return;
        }

        if (this.vto.customKitSingleContext?.fromCustomKit) {
          const variantId = this.getSelectedVariantId();
          if (!variantId) return;

          if (e) {
            e.preventDefault();
            e.stopPropagation();
          }

          const { productId, collectionId } = this.vto.customKitSingleContext;
          document.dispatchEvent(new CustomEvent('custom-kit:add-item-from-vto', {
            detail: {
              productId,
              variantId,
              collectionId
            }
          }));

          window.YMK?.close?.();
          const findMyShadeModal = document.querySelector('#findMyShadeModal');
          findMyShadeModal?.hide?.();
          this.hide();
          return;
        }

        window.YMK.close();
        const findMyShadeModal = document.querySelector('#findMyShadeModal');
        findMyShadeModal.hide();
      }

      handleAddToKitClick() {
        const variantId = this.vto.components.vtoAddToBagButton?.getAttribute('data-selected-variant-id');
        if (!variantId) {
          return;
        }

        const currentProduct = this.vto.multiProduct.products[this.vto.multiProduct.currentIndex];
        if (!currentProduct) return;

        const collectionId = this.vto.multiProduct.collectionId || currentProduct.of_collection_id || null;

        document.dispatchEvent(new CustomEvent('custom-kit:add-item-from-vto', {
          detail: {
            productId: currentProduct.id,
            variantId: Number(variantId),
            collectionId
          }
        }));

        // Clear multi-product VTO context after adding to kit unless persistence requested
        if (window.__multiVtoMeta?.persistAfterClose !== true) {
          window.__multiVtoProducts = null;
          window.__multiVtoMeta = null;
        }

        window.YMK?.close?.();
        const findMyShadeModal = document.querySelector('#findMyShadeModal');
        findMyShadeModal?.hide?.();
        this.hide();
      }
      async handleEditCartFormSubmit(evt) {
        if (!window.isFromQvCart || !window.qvCartItemKey || typeof window.replaceCartItem !== 'function') {
          return;
        }

        evt.preventDefault();
        evt.stopImmediatePropagation();

        const variantId = this.vto.components.vtoAddToBagFormInput?.value;
        if (!variantId) return;

        const submitButton = evt.target.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }

        try {
          const promoProps = window.getPromoLineItemProperties ? {
            ...window.getPromoLineItemProperties(
              ['#quickshop-cart product-info[data-view-context="Quickview"]']
            ),
            ...window.getPromoLineItemProperties(
              ['#quickshop-cart product-info[data-view-context="Quickview"]'],
              { mode: 'flags' }
            ),
          } : {};

          await window.replaceCartItem(window.qvCartItemKey, variantId, undefined, { '_source': 'vto', ...promoProps }, false);
          window.YMK.close();
          window.isFromQvCart = false;
          window.qvCartItemKey = null;
        } catch (error) {
          console.error('Error replacing cart item from VTO:', error);
        } finally {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
        }
      }

      handleDisplayAllShades() {
        this.toggleVtoExperience();
      }

      handleRemoveButtonClick() {
        this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
        this.vto.components.circleSwatches.forEach(btn => btn.classList.remove('checked'));
        this.vto.components.vtoAddToBagButton.removeAttribute('data-selected-variant-available');
        this.vto.components.vtoAddToBagButton.removeAttribute('data-selected-variant-id');
        this.vto.components.vtoAddToBagButton.disabled = true;
        this.vto.components.shadeName.textContent = ' ';
        this.vto.components.shadeInputs.forEach((input) => {
          input.checked = false;
        });
        window.YMK.reset();

        // If wizard mode, delete saved selection and update badge/button
        if (this.vto.wizard.isWizard) {
          delete this.vto.wizard.selectedShades[this.vto.wizard.currentIndex];
          this.resetCurrentBadgeToNoSelection();
          this.updateWizardButtonVisibility();
        }
      }

      resetSwatches() {
        this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
        this.vto.components.shadeInputs.forEach((input) => {
          input.checked = false;
        });
        this.vto.components.shadeName.textContent = this.vto.components.shadeName.dataset.defaultname;
      }

      handleYouCamCloseEvent() {
        // Don't close modal if we're intentionally reloading camera for wizard navigation
        if (this.vto.wizard.isWizard && this.vto.wizard.isReloadingCamera) {
          return;
        }

        this.vto.components.legalCheckBox.checked = false;
        this.vto.components.getStartedButton.disabled = false;
        this.resetSwatches();
        this.hide();
        removeTrapFocus();
      }

      handleShadeFinderCompleteEvent(result) {
        const filteredIDs = this.filterIDs(result.recommendations);
      
        if (filteredIDs) {
          const entries = ['warmer', 'cooler', 'lighter', 'darker', 'matched'];
      
          entries.forEach(key => {
            const entry = filteredIDs[key];
            const smartSwatchContainer = this.querySelector(`.smart-experience-suggestions .${key}`);
            if (!entry || !entry.skuId) {
              smartSwatchContainer.classList.add('hidden');
            } else {
              const vtoSwatch = this.querySelector(`.vto-modal__swatch[data-variant-barcode="${entry.skuId}"]:not(smart-result-swatch)`);
              const vtoSwatchInput = vtoSwatch?.querySelector('input');
              if (vtoSwatch && vtoSwatchInput && vtoSwatch.dataset.variantSwatchImg) {
                smartSwatchContainer.classList.remove('hidden');
                const isOos = vtoSwatch.classList.contains('oos');
                const smartSwatch = smartSwatchContainer.querySelector('.vto-modal__swatch');
                const smartSwatchInput = smartSwatch.querySelector('input');
                const smartSwatchImg = smartSwatch.querySelector('img');
                
                smartSwatch.setAttribute('data-variant-title', vtoSwatch.dataset.variantTitle);
                smartSwatch.setAttribute('data-variant-barcode', vtoSwatch.dataset.variantBarcode);
                smartSwatch.setAttribute('data-variant-id', vtoSwatch.dataset.variantId);
                smartSwatch.setAttribute('data-variant-swatch-img', vtoSwatch.dataset.variantSwatchImg);
                smartSwatchInput.name = 'smart-' + vtoSwatchInput.name;
                smartSwatchInput.value = vtoSwatchInput.value;
                smartSwatchImg.alt = vtoSwatch.dataset.variantTitle;
                smartSwatchImg.title = vtoSwatch.dataset.variantTitle;
                smartSwatchImg.src = vtoSwatch.dataset.variantSwatchImg;

                if (isOos) {
                  smartSwatch.classList.add('oos');
                  smartSwatchInput.disabled = true;
                }

                // // update shade-match local storage with inital match
                if (key === 'matched') {
                  const data = {
                    handle: this.dataset.handle,
                    barcode: vtoSwatch.dataset.variantBarcode,
                    featureID: 'vto'
                  };
                  document.body.dispatchEvent(new CustomEvent('shadeMatch:setData', { detail : data }));
                  vtoSwatch.click();
                }
              } else {
                smartSwatchContainer.classList.add('hidden');
              }
            }
          });

          if (document.querySelector('.smart-experience-suggestions .matched .swatch').getAttribute('data-variant-id').length > 0) {
            document.querySelector('.smart-experience-suggestions .matched .swatch').click();
          }
          this.toggleVtoExperience('Smart');
        }
      }
      

      filterIDs(results) {
        let result = null;
        if (results) {
          let deltaE = 10;
          let variantIDs = this.vto.state.variantBarcodes;
          if (variantIDs.length > 0) {
            for (var j = 0; j < results.length; j++) {
                if (typeof results[j].guid.skuId !== 'undefined' && variantIDs.includes(results[j].guid.skuId) && results[j].delta_e < deltaE) {
                    result = results[j];
                    deltaE = results[j].delta_e;
                }
            }
          }
        }
        return result;
      }

      handleCameraFailedEvent() {
        this.toggleVtoExperience('Basic');
      }

      handleUIDisplay() {
        const vtoUI = this.querySelector('.vto-modal__all-experiences-inner-wrapper');
        vtoUI?.classList.remove('ghost');
        if (!this.vto.state.hasShadeSelection) {
          this.applySelectedVariantToVto();
        }
      }

      initEventListeners() {
        this.vto.components.legalCheckBox.addEventListener('change', () => {  this.vto.components.getStartedButton.disabled = !this.vto.components.legalCheckBox.checked; });
        this.vto.components.getStartedButton.addEventListener( 'click', this.handleGetStartClick.bind(this));
        this.vto.components.modalBackButton.addEventListener('click', this.handleBackButtonClick.bind(this));
        this.vto.components.swatches.forEach(swatch => { swatch.addEventListener('click', this.handleSwatchClick.bind(this)) });
        this.vto.components.removeButton.forEach(button => {button.addEventListener('click', this.handleRemoveButtonClick.bind(this))});
        this.vto.components.vtoAddToBagButton.disabled = true;
        this.vto.components.vtoAddToBagButton.addEventListener('click', this.handleAddToBagClick.bind(this));
        this.vto.components.allShadesButton.addEventListener('click', this.handleDisplayAllShades.bind(this));

        // Intercept form submission for edit cart context (single products)
        const singleProductForm = this.querySelector('#vto_modal_add_form');
        if (singleProductForm && !this.vto.wizard.isWizard) {
          singleProductForm.addEventListener('submit', this.handleEditCartFormSubmit.bind(this), true);
        }

        // Bundle wizard product navigation
        if (this.vto.wizard.isWizard) {
          if (this.vto.components.wizardPrevButton) {
            this.vto.components.wizardPrevButton.addEventListener('click', this.handleWizardPrev.bind(this));
          }
          if (this.vto.components.wizardNextButton) {
            this.vto.components.wizardNextButton.addEventListener('click', this.handleWizardNext.bind(this));
          }
          if (this.vto.components.wizardFinishButton) {
            this.vto.components.wizardFinishButton.addEventListener('click', this.handleWizardFinish.bind(this));
          }

          // Review experience navigation
          const reviewBackButton = this.querySelector('[data-review-back]');
          if (reviewBackButton) {
            reviewBackButton.addEventListener('click', this.handleReviewBack.bind(this));
          }

          const reviewCloseButton = this.querySelector('[data-review-close]');
          if (reviewCloseButton) {
            reviewCloseButton.addEventListener('click', this.handleReviewClose.bind(this));
          }

          // Intercept form submission for wizard bundles
          const productForms = this.querySelectorAll('product-form');
          productForms.forEach(productForm => {
            const form = productForm.querySelector('form');
            if (form) {
              form.addEventListener('submit', this.handleBundleWizardFormSubmit.bind(this), true);
            }
          });
        }
      }

      // bundle add to bag
      async handleBundleWizardFormSubmit(evt) {
        // Only intercept for wizard mode
        if (!this.vto.wizard.isWizard) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        // Get bundle metadata from hidden inputs or data attributes
        const bundleProductId = this.querySelector('input[name="bundle_product_id"]')?.value || this.getAttribute('data-opener-product-id');
        const bundleProductName = this.querySelector('input[name="bundle_product_name"]')?.value;
        const bundleSku = this.querySelector('input[name="bundle_sku"]')?.value;
        const bundleHandle = this.querySelector('input[name="bundle_handle"]')?.value;
        const bundleShade = this.querySelector('input[name="bundle_shade"]')?.value;
        const bundleSize = this.querySelector('input[name="bundle_size"]')?.value;
        const bundleImage = this.querySelector('input[name="bundle_image"]')?.value;

        // Get the submit button and cart elements
        const submitButton = evt.target.querySelector('[type="submit"]');
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }

        // Create unique bundle key
        const bundleKey = `bundle_${new Date().getTime()}`;

        // Get parent variant ID (first available variant from the bundle parent product)
        const parentVariantId = this.querySelector('.product-variant-id')?.value;

        // Get promo flags if available
        const promoFlags = window.getPromoLineItemProperties ?
          window.getPromoLineItemProperties(
            ['.product-section product-info[data-view-context="PDP"]', 'product-info[data-view-context="Quickview"]'],
            { mode: 'flags' }
          ) : {};

        const resetSubmitButton = () => {
          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
        };

        // Build the bundle components from ALL bundle products
        const bundleComponents = [];
        const resolvedBundleHandles = [];
        const unresolvedBundleHandles = [];
        const allHandles = (this.vto.wizard.allBundleHandles.length > 0 ? this.vto.wizard.allBundleHandles : this.vto.wizard.handles).filter(Boolean);

        allHandles.forEach((handle, bundleIndex) => {
          const productData = this.getWizardProductData()?.[handle];

          // Find if this product has a selection in the wizard. Match by occurrence so duplicate handles keep slot identity.
          const handleOccurrence = allHandles.slice(0, bundleIndex + 1).filter(itemHandle => itemHandle === handle).length - 1;
          const matchingWizardIndexes = this.vto.wizard.handles
            .map((wizardHandle, wizardIndex) => wizardHandle === handle ? wizardIndex : -1)
            .filter(wizardIndex => wizardIndex !== -1);
          const wizardIndex = matchingWizardIndexes[handleOccurrence] ?? matchingWizardIndexes[0] ?? -1;
          const selection = wizardIndex !== -1 ? this.vto.wizard.selectedShades[wizardIndex] : null;

          let variantId = null;

          if (selection && selection.variantID) {
            // Product with shade selection from wizard
            variantId = selection.variantID;
          } else if (productData && productData.variants && productData.variants.length > 0) {
            // Product without shade selection - use first available variant
            variantId = productData.variants[0].id;
          }

          if (variantId) {
            resolvedBundleHandles.push(handle);
            bundleComponents.push({
              merchandiseId: window.toShopifyVariantGid(variantId),
              variantId: String(variantId),
              quantity: 1,
              slot: String(bundleIndex + 1),
              productHandle: handle
            });
          } else {
            unresolvedBundleHandles.push({
              handle,
              title: productData?.title || handle
            });
          }
        });

        if (unresolvedBundleHandles.length > 0) {
          const unavailableProductNames = Array.from(new Set(unresolvedBundleHandles
            .map(product => product.title)
            .filter(Boolean)));
          const unavailableProductList = unavailableProductNames.join(', ');
          const unavailableMessage = unavailableProductList
            ? `This bundle is not available in your market because ${unavailableProductList} ${unavailableProductNames.length === 1 ? 'is' : 'are'} unavailable. Please try another bundle.`
            : 'This bundle is not available in your market because one or more items are unavailable. Please try another bundle.';

          console.error('Unable to add VTO bundle: missing market-available variant for bundle products:', unresolvedBundleHandles);
          alert(unavailableMessage);
          resetSubmitButton();
          return;
        }

        if (bundleComponents.length === 0) {
          console.error('No items selected in wizard');
          resetSubmitButton();
          return;
        }

        const items = [window.buildBundleLineItem({
          parentVariantId,
          components: bundleComponents,
          properties: {
            '_source': 'vto',
            '_bundle_key': bundleKey,
            '_parent_id': parentVariantId,
            '_bundle_sku': bundleSku,
            '_bundle_name': bundleProductName,
            '_bundle_product_handles': resolvedBundleHandles.join(','),
            '_bundle_image': bundleImage,
            '_bundle_product_id': bundleProductId,
            '_bundle_handle': bundleHandle,
            '_bundle_shade': bundleShade,
            '_bundle_size': bundleSize,
            ...promoFlags
          }
        })];

        // Skip max quantity check when editing an existing bundle in cart
        const isEditMode = window.isFromQvCart && window.qvCartItemKey;
        if (!isEditMode) {
        const productInfoContainer = this.vto.components.review.querySelector('.vto-review__product-metafields-data');
        const variantIdNumber = Number(parentVariantId);
        const shouldBlock = await window.preventAddIfMaxedOut(variantIdNumber, productInfoContainer);
        if (shouldBlock) {
          window.YMK.close();

          if (submitButton) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          }
          return;
        }
        }

        // Handle edit cart context - replace bundle instead of adding
        if (window.isFromQvCart && window.qvCartItemKey) {
          try {
            const initialCart = await fetch('/cart.js').then(res => res.json());
            const existingItem = initialCart.items.find(item => item.key === window.qvCartItemKey);

            if (existingItem) {
              const existingBundleKey = existingItem.properties?._bundle_key;
              const itemsToRemove = existingBundleKey
                ? initialCart.items.filter(item => item.properties?._bundle_key === existingBundleKey)
                : [existingItem];

              for (const item of itemsToRemove) {
                await fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: item.key, quantity: 0 }),
                });
              }
              await new Promise(resolve => setTimeout(resolve, 300));
            }

            await fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items })
            });

            const sectionResponse = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer`);
            if (sectionResponse.ok) {
              const sections = await sectionResponse.json();
              window.cartDrawer?.renderContents(sections);
            }

            window.YMK.close();
            document.querySelector('#findMyShadeModal')?.hide();
            document.querySelector('#Quickshop-Modal-cart')?.hide();
            window.isFromQvCart = false;
            window.qvCartItemKey = null;
          } catch (error) {
            console.error('Error replacing bundle cart item from VTO:', error);
          } finally {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
          }
          return;
        }

        // Add items to cart (normal flow)
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: items,
            sections: cart ? cart.getSectionsToRender().map(section => section.id) : []
          })
        })
          .then(response => response.json())
          .then(response => {
            if (response.status) {
              console.error('Cart add error:', response);
              alert(response.description || 'Error adding to cart');
            } else {
              // Publish cart update event for localStorage sync and other listeners
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'vto-modal',
                cartData: response,
              });

              // Success - update cart UI
              if (cart && response.sections) {
                cart.renderContents(response);
              }

              // Close the modal
              window.YMK.close();
              const findMyShadeModal = document.querySelector('#findMyShadeModal');
              if (findMyShadeModal) {
                findMyShadeModal.hide();
              }
            }
          })
          .catch(error => {
            console.error('Cart add error:', error);
            alert('Error adding to cart');
          })
          .finally(() => {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
          });
      }

      initYouCamWindow() {
        const _this = this;
        const windowWidth = window.innerWidth < window.screen.width ? window.innerWidth : window.screen.width;
        const ymkModuleWidth = windowWidth < 480 ? windowWidth : 375;
        const ymkSettings = {
          width: ymkModuleWidth,
          height: ymkModuleWidth, // square
          shadeFinderResultVersion: 'v2',
          shadeFinderDeltaEThreshold: 100,
          userConsent: 'agree'
        };

        window.ymkAsyncInit = (function () {
            window.YMK.init(ymkSettings);
            _this.vto.state.ymkAsyncInitialized = true;

            // set ymk event listeners
            // window.YMK.addEventListener('opened', function () {
            //   handleOpenEvent();
            // });
            window.YMK.addEventListener('closed', function () {
              _this.handleYouCamCloseEvent();
            });
            window.YMK.addEventListener('shadeFinderComplete', function (result) {
              _this.handleShadeFinderCompleteEvent(result);
            });
            window.YMK.addEventListener('cameraFailed', function () {
              _this.handleCameraFailedEvent();
            });
            window.YMK.addEventListener('loaded', function () {
              // handleLoadedEvent();
              _this.handleUIDisplay();
            });
            window.YMK.addEventListener('engineClosed', function () {
              // handleEngineClosedEvent();
              const vtoUI = _this.querySelector('.vto-modal__all-experiences-inner-wrapper');
              vtoUI?.classList.add('ghost');
            });
        }());
      }

      // TODO: possibly add code here to account opening, reopening, switching back and forth between basic and smart
      openShadeFinder() {
        window.YMK.openShadeFinder();
        // start by displaying the Basic swatches until handleShadeFinderCompleteEvent() renders the results
        this.toggleVtoExperience('Basic');
      }

      async initSwatchSwiper() {
        const vtoShadeCarousel = this.querySelector('.vto-modal__swatch-swiper');
        if (!vtoShadeCarousel) return;

        if (!window.reduceShadeSelection) {
          window.reduceShadeSelection = { reduceShades: false };
        }

        const vtoExperience = this.querySelector('.vto-modal__content');
        const reducedAttr =
          vtoExperience?.querySelector('[data-reduced-shades]')?.getAttribute('data-reduced-shades') ||
          vtoExperience?.getAttribute('data-reduced-shades') ||
          this.getAttribute('data-reduced-shades') ||
          '';
        const reducedTarget = (reducedAttr || '').toLowerCase().trim();

        let shouldRemoveSlidesFn =
          typeof window.shouldRemoveSlides === 'function'
            ? window.shouldRemoveSlides
            : await this.waitForWindowProperty('shouldRemoveSlides').catch(() => null);

        if (!shouldRemoveSlidesFn) {
          shouldRemoveSlidesFn = async (target) => {
            return false;
          };
        }

        let shouldReduceShades = false;
        try {
          shouldReduceShades = await shouldRemoveSlidesFn(reducedTarget);
        } catch (e) {
          shouldReduceShades = false;
        }

        window.reduceShadeSelection = { reduceShades: !!shouldReduceShades };

        if (window.reduceShadeSelection.reduceShades) {
          const nonReducedShades = vtoShadeCarousel.querySelectorAll('.swiper-wrapper .vto-modal__swatch[data-include-reduced="false"]');
          nonReducedShades.forEach(shade => shade.remove());
        }

        const slideSelector = window.reduceShadeSelection.reduceShades
          ? '.swiper-wrapper .vto-modal__swatch[data-include-reduced="true"]'
          : '.swiper-wrapper .vto-modal__swatch';

        const slides = vtoShadeCarousel.querySelectorAll(slideSelector);
        const vtoSwiperSwatchesCount = slides.length;


        if (vtoSwiperSwatchesCount > 6) {
          this.querySelector('.vto-modal__swiper-button-prev')?.classList.remove('hidden');
          this.querySelector('.vto-modal__swiper-button-next')?.classList.remove('hidden');
        }

        new Swiper(vtoShadeCarousel, {
          slidesPerView: 6,
          slidesPerGroup: 6,
          spaceBetween: 12,
          centerInsufficientSlides: true,
          allowTouchMove: true,
          loop: false,
          navigation: {
              nextEl: '.vto-modal__swiper-button-next',
              prevEl: '.vto-modal__swiper-button-prev'
          },
          breakpoints: {
            736: {
                slidesPerView: 6,
                slidesPerGroup: 6,
                spaceBetween: 12,
            }
          }
        });
      }

      appendYouCamScript() {
        if (typeof (YMK) === 'undefined') {
          (function (d,v,k) {
            var s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://plugins-media.makeupar.com/' + v + '/sdk.js?apiKey=' + k;
            var x = d.getElementsByTagName('script')[0];
            x.parentNode.insertBefore(s, x);
          })(document, this.vto.state.versionID, this.vto.state.apiKey);
        }
      }

      toggleVtoExperience(experienceType) {
        switch (experienceType) {
          // TODO ADA call trapFocus from sites/tarte/assets/global.js on the opened experience
          case 'Basic' : 
            this.vto.components.basicExperience.classList.remove('hidden');
            this.vto.components.smartExperience.classList.add('hidden');
            trapFocus(this.vto.components.modalContent);
            break;
          case 'Smart' :
            this.vto.components.basicExperience.classList.add('hidden');
            this.vto.components.smartExperience.classList.remove('hidden');
            trapFocus(this.vto.components.modalContent, this.vto.components.modalContent);
            this.handleUIDisplay();
            break;
          default:
            // Basic
            this.vto.components.basicExperience.classList.remove('hidden');
            this.vto.components.smartExperience.classList.add('hidden');
            trapFocus(this.vto.components.modalContent);
        }
      }

      // ========================================
      // Bundle wizard experience
      // ========================================
      initializeWizardBadges() {
        // Initialize all product badges to show "no selection" state
        this.vto.components.wizardProductImages.forEach((productImage, index) => {
          const badge = productImage.querySelector('.vto-wizard__shade-badge');
          if (badge) {
            // Show badge with no-selection class
            badge.classList.add('no-selection');
            badge.style.display = 'block';
          }
        });
      }

      updateWizardBadge(productIndex, swatchImgUrl, variantTitle) {
        const productImage = this.vto.components.wizardProductImages[productIndex];
        if (productImage) {
          const badge = productImage.querySelector('.vto-wizard__shade-badge');
          if (badge && swatchImgUrl) {
            badge.classList.remove('no-selection');
            badge.style.backgroundImage = `url(${swatchImgUrl})`;
            badge.style.display = 'block';
            productImage.classList.add('has-selection');
          }
        }
      }

      reapplyWizardMakeup() {
        // Reset YMK first
        window.YMK.reset();
        this.vto.state.previousBarcode = null;

        // Re-apply all saved products except the current one
        Object.keys(this.vto.wizard.selectedShades).forEach(index => {
          const parsedIndex = parseInt(index);
          if (parsedIndex !== this.vto.wizard.currentIndex) {
            const shade = this.vto.wizard.selectedShades[parsedIndex];
            if (shade && shade.barcode) {
              window.YMK.applyMakeupBySku(shade.barcode);
            }
          }
        });
      }

      updateWizardButtonVisibility() {
        const currentIndex = this.vto.wizard.currentIndex;
        const totalProducts = this.vto.wizard.handles.length;
        const selection = this.vto.wizard.selectedShades[currentIndex];
        const hasSelection = !!selection && selection.available !== false;

        if (totalProducts === 1) {
          // Single product bundle: hide Previous, hide Next, show Finish
          this.vto.components.wizardPrevButton?.classList.add('hidden');
          this.vto.components.wizardNextButton?.classList.add('hidden');
          this.vto.components.wizardFinishButton?.classList.remove('hidden');
          // Disable Finish if no selection
          if (this.vto.components.wizardFinishButton) {
            this.vto.components.wizardFinishButton.disabled = !hasSelection;
          }
        } else if (currentIndex === 0) {
          // First product: hide Previous, show Next, hide Finish
          this.vto.components.wizardPrevButton?.classList.add('hidden');
          this.vto.components.wizardNextButton?.classList.remove('hidden');
          this.vto.components.wizardFinishButton?.classList.add('hidden');
          // Disable Next if no selection
          if (this.vto.components.wizardNextButton) {
            this.vto.components.wizardNextButton.disabled = !hasSelection;
          }
        } else if (currentIndex === totalProducts - 1) {
          // Last product: show Previous, hide Next, show Finish
          this.vto.components.wizardPrevButton?.classList.remove('hidden');
          this.vto.components.wizardNextButton?.classList.add('hidden');
          this.vto.components.wizardFinishButton?.classList.remove('hidden');
          // Disable Finish if no selection
          if (this.vto.components.wizardFinishButton) {
            this.vto.components.wizardFinishButton.disabled = !hasSelection;
          }
        } else {
          // Middle products: show Previous, show Next, hide Finish
          this.vto.components.wizardPrevButton?.classList.remove('hidden');
          this.vto.components.wizardNextButton?.classList.remove('hidden');
          this.vto.components.wizardFinishButton?.classList.add('hidden');
          // Disable Next if no selection
          if (this.vto.components.wizardNextButton) {
            this.vto.components.wizardNextButton.disabled = !hasSelection;
          }
        }
      }

      loadWizardProductAtCurrentIndex() {
        const handle = this.vto.wizard.handles[this.vto.wizard.currentIndex];
        const wizardProductData = this.getWizardProductData();
        if (wizardProductData && wizardProductData[handle]) {
          this.updateWizardProduct(wizardProductData[handle]);
          this.updateWizardButtonVisibility();
        } else {
          console.error('No pre-loaded data found for handle:', handle);
        }
      }

      resetCurrentBadgeToNoSelection() {
        const productImage = this.vto.components.wizardProductImages[this.vto.wizard.currentIndex];
        if (productImage) {
          const badge = productImage.querySelector('.vto-wizard__shade-badge');
          if (badge) {
            badge.classList.add('no-selection');
            badge.style.backgroundImage = '';
            productImage.classList.remove('has-selection');
          }
        }
      }

      async handleWizardPrev(e) {
        e?.preventDefault();
        e?.stopPropagation();

        if (this.vto.wizard.currentIndex > 0) {
          this.vto.wizard.currentIndex--;
          await this.refreshVtoBundleAvailability({ forceFetch: false });
          this.loadWizardProductAtCurrentIndex();
        }
      }

      async handleWizardNext(e) {
        e?.preventDefault();
        e?.stopPropagation();

        if (this.vto.wizard.currentIndex < this.vto.wizard.handles.length - 1) {
          this.vto.wizard.currentIndex++;
          await this.refreshVtoBundleAvailability({ forceFetch: false });
          this.loadWizardProductAtCurrentIndex();
        }
      }

      handleWizardFinish(e) {
        e?.preventDefault();
        e?.stopPropagation();

        // Show review experience and populate it with selections
        this.showReviewExperience();
      }

      async handleReviewBack(e) {
        e?.preventDefault();
        e?.stopPropagation();

        // Hide review and show all experiences
        if (this.vto.components.review) {
          this.vto.components.review.classList.add('hidden');
        }
        if (this.vto.components.allExperiences) {
          this.vto.components.allExperiences.classList.remove('hidden');
        }
        if (this.vto.components.modalToggleButton) {
          this.vto.components.modalToggleButton.classList.remove('hidden');
        }

        // Reset to last product
        this.vto.wizard.currentIndex = this.vto.wizard.handles.length - 1;
        await this.refreshVtoBundleAvailability({ forceFetch: false });
        this.loadWizardProductAtCurrentIndex();
      }

      handleReviewClose(e) {
        e?.preventDefault();
        e?.stopPropagation();

        // Close YMK and hide the modal
        window.YMK.close();
      }

      showReviewExperience() {
        // Hide legal and all experiences
        if (this.vto.components.legal) {
          this.vto.components.legal.classList.add('hidden');
        }
        if (this.vto.components.allExperiences) {
          this.vto.components.allExperiences.classList.add('hidden');
        }
        if (this.vto.components.modalToggleButton) {
          this.vto.components.modalToggleButton.classList.add('hidden');
        }

        // Show review only
        if (this.vto.components.review) {
          this.vto.components.review.classList.remove('hidden');
        }

        // Update add to bag button text for bundle review
        const reviewAddButton = this.vto.components.review?.querySelector('.cta-button .cta-content');
        if (reviewAddButton) {
          reviewAddButton.textContent = 'ADD BUNDLE TO BAG';
        }

        // Populate review with all bundle products and their selections
        const reviewProducts = this.querySelectorAll('.vto-review__product-item');

        reviewProducts.forEach(productItem => {
          const handle = productItem.getAttribute('data-product-handle');
          const shadePlaceholder = productItem.querySelector('[data-shade-placeholder]');

          if (shadePlaceholder) {
            // Find if this product has a VTO/shade match selection
            const productIndex = this.vto.wizard.handles.indexOf(handle);

            if (productIndex !== -1 && this.vto.wizard.selectedShades[productIndex]) {
              // This product was in the wizard and has a selection
              const shade = this.vto.wizard.selectedShades[productIndex];

              // Clear placeholder and create swatch display
              shadePlaceholder.innerHTML = '';

              // Create swatch image
              const swatchImg = document.createElement('img');
              swatchImg.src = shade.swatchImg;
              swatchImg.alt = shade.variantTitle;
              swatchImg.className = 'vto-review__swatch-image';

              // Create shade name text
              const shadeText = document.createElement('span');
              shadeText.textContent = shade.variantTitle;
              shadeText.className = 'vto-review__shade-text';

              shadePlaceholder.appendChild(swatchImg);
              shadePlaceholder.appendChild(shadeText);
            } else if (productIndex !== -1) {
              // This product was in the wizard but no shade was selected
              shadePlaceholder.textContent = 'No shade selected';
              shadePlaceholder.style.color = 'var(--grayscale-400)';
            } else {
              // This product was not part of the wizard (no VTO/shade match)
              shadePlaceholder.textContent = 'One size';
              shadePlaceholder.style.fontStyle = 'italic';
            }
          }
        });
      }

      updateWizardProduct(productData) {
        // Only reload camera when moving from product 0 to product 1, product 0 has shade match,
        // and we haven't already done the initial reload
        const firstHandle = this.vto.wizard.handles[0];
        const firstProductData = this.getWizardProductData()?.[firstHandle];
        const shouldReloadCamera = this.vto.wizard.currentIndex === 1 &&
                                   firstProductData?.hasShadeMatch === true &&
                                   !this.vto.wizard.hasReloadedCamera;

        if (shouldReloadCamera) {
          this.vto.wizard.hasReloadedCamera = true;
          this.vto.wizard.isReloadingCamera = true;
          try {
            const handleCameraReopened = () => {
              this.vto.wizard.isReloadingCamera = false;
              window.YMK.removeEventListener('opened', handleCameraReopened);
            };
            window.YMK.addEventListener('opened', handleCameraReopened);
            const videoElement = document.querySelector('#YMK-module video');
            if (videoElement && videoElement.srcObject) {
              const stream = videoElement.srcObject;
              const tracks = stream.getTracks();
              tracks.forEach(track => track.stop());
              requestAnimationFrame(() => {
                if (window.YMK && window.YMK.open) {
                  window.YMK.open(true);
                }
              });
            } else {
              this.vto.wizard.isReloadingCamera = false;
              window.YMK.removeEventListener('opened', handleCameraReopened);
            }
          } catch (e) {
            this.vto.wizard.isReloadingCamera = false;
          }
        }

        // Reset to basic experience (hide smart experience if it was showing)
        if (this.vto.components.smartExperience && this.vto.components.basicExperience) {
          this.vto.components.smartExperience.classList.add('hidden');
          this.vto.components.basicExperience.classList.remove('hidden');
        }

        // Update active product image
        this.vto.components.wizardProductImages.forEach((img, idx) => {
          if (idx === this.vto.wizard.currentIndex) {
            img.classList.add('active');
          } else {
            img.classList.remove('active');
          }
        });

        // Reset shade name to default (will be updated if saved selection exists)
        if (this.vto.components.shadeName) {
          const defaultName = this.vto.components.shadeName.getAttribute('data-default-name');
          this.vto.components.shadeName.textContent = defaultName || 'Select a shade';
        }

        // Update modal data attributes for YMK
        this.setAttribute('data-masterid', productData.id);
        this.setAttribute('data-handle', productData.handle);
        this.setAttribute('data-vto-type', productData.vtoType || 'Basic');

        // Update barcodes
        const selectableVariants = this.getSelectableVtoVariants(productData);
        const barcodes = selectableVariants
          .map(v => v.barcode)
          .filter(b => b);
        this.setAttribute('data-variant-barcodes', `[${barcodes.join(',')}]`);
        this.vto.state.variantBarcodes = `[${barcodes.join(',')}]`;

        // Update vto state
        this.vto.masterId = productData.id;
        this.vto.state.experienceType = productData.vtoType || 'Basic';

        // Update title
        if (this.vto.components.productTitle) {
          this.vto.components.productTitle.textContent = productData.title;
        }

        // Clear and update swatches
        if (this.vto.components.swatchContainer) {
          this.vto.components.swatchContainer.innerHTML = '';

          const isReducedMode = !!(window.reduceShadeSelection && window.reduceShadeSelection.reduceShades);
          const allVariants = Array.isArray(productData?.variants) ? productData.variants : [];
          const renderVariants = isReducedMode
            ? allVariants.filter(v => v.inReduced)
            : allVariants;
          // Add "no selection" swatch for wizard mode only
          if (this.vto.wizard.isWizard) {
            const noSelectionDiv = document.createElement('div');
            noSelectionDiv.className = 'vto-modal__swatch swatch swiper-slide vto-modal__remove-style';
            noSelectionDiv.setAttribute('data-no-selection', 'true');
            const circleSwatchDiv = document.createElement('div');
            circleSwatchDiv.className = 'vto-modal__circle-swatch circle-swatch';
            const input = document.createElement('input');
            input.type = 'radio';
            input.id = 'vto-modal__swiper-swatch-no-selection';
            input.name = 'vto-swiper-swatch';
            input.value = 'no-selection';
            input.className = 'vto-shade-input';
            const label = document.createElement('label');
            label.setAttribute('for', 'vto-modal__swiper-swatch-no-selection');
            circleSwatchDiv.appendChild(input);
            circleSwatchDiv.appendChild(label);
            noSelectionDiv.appendChild(circleSwatchDiv);
            this.vto.components.swatchContainer.appendChild(noSelectionDiv);
          }

          renderVariants.forEach((variant, index) => {
            const isSelectable = this.isVtoVariantSelectable(variant, this.vto.wizard.currentIndex);
            const swatchDiv = document.createElement('div');
            swatchDiv.className = 'vto-modal__swatch swatch swiper-slide shade-variant';
            if (!isSelectable) {
              swatchDiv.classList.add('oos');
            }
            swatchDiv.setAttribute('data-variant-title', variant.title);
            swatchDiv.setAttribute('data-variant-barcode', variant.barcode || '');
            swatchDiv.setAttribute('data-variant-id', variant.id);
            swatchDiv.setAttribute('data-include-reduced', variant.inReduced ? 'true' : 'false');

            // Use pre-loaded swatch image thumbnail for the data attribute
            if (variant.swatchImgThumb) {
              swatchDiv.setAttribute('data-variant-swatch-img', variant.swatchImgThumb);
            }

            // Create the inner HTML structure with proper attributes
            const circleSwatchDiv = document.createElement('div');
            circleSwatchDiv.className = 'vto-modal__circle-swatch circle-swatch';

            const input = document.createElement('input');
            input.type = 'radio';
            input.id = `vto-modal__swiper-swatch-${index}`;
            input.name = 'vto-swiper-swatch';
            input.value = variant.options || variant.title;
            input.className = 'vto-shade-input';
            input.disabled = !isSelectable;

            const label = document.createElement('label');
            label.setAttribute('for', `vto-modal__swiper-swatch-${index}`);

            const img = document.createElement('img');
            // Use full swatch image for the img src
            img.src = variant.swatchImg || '';
            // Use variant.options for alt and title (like reference code)
            img.alt = variant.options || variant.title;
            img.title = variant.options || variant.title;

            label.appendChild(img);
            circleSwatchDiv.appendChild(input);
            circleSwatchDiv.appendChild(label);
            swatchDiv.appendChild(circleSwatchDiv);

            this.vto.components.swatchContainer.appendChild(swatchDiv);
          });

          // Re-add event listeners to new swatches
          const newSwatches = this.vto.components.swatchContainer.querySelectorAll('.vto-modal__swatch');
          newSwatches.forEach(swatch => {
            swatch.addEventListener('click', this.handleSwatchClick.bind(this));
          });

          // Force Swiper to recalculate slide widths immediately so new slides don't
          // briefly render at their natural (unconstrained) size before the async observer fires.
          const swatchSwiperEl = this.querySelector('.vto-modal__swatch-swiper');
          swatchSwiperEl?.swiper?.update();

          // Update component references
          this.vto.components.swatches = this.querySelectorAll('.vto-modal__swatch');

          if (renderVariants.length === 1 && this.isVtoVariantSelectable(renderVariants[0], this.vto.wizard.currentIndex)) {
            // Single-variant product: auto-select and hide shade picker
            const singleSwatch = this.vto.components.swatchContainer.querySelector('.vto-modal__swatch:not([data-no-selection])');
            if (singleSwatch) {
              singleSwatch.click();
            }
            this.vto.components.shadeName?.classList.add('hidden');
            this.querySelector('.vto-modal__swatch-swiper-wrapper')?.classList.add('hidden');
          } else {
            this.vto.components.shadeName?.classList.remove('hidden');
            this.querySelector('.vto-modal__swatch-swiper-wrapper')?.classList.remove('hidden');
            // Restore saved selection if it exists for this product
            if (this.vto.wizard.selectedShades[this.vto.wizard.currentIndex]) {
              const savedShade = this.vto.wizard.selectedShades[this.vto.wizard.currentIndex];

              // Update shade name
              if (this.vto.components.shadeName) {
                this.vto.components.shadeName.textContent = savedShade.variantTitle;
              }

              // Find and select the matching swatch
              const matchingSwatch = this.vto.components.swatchContainer.querySelector(
                `[data-variant-swatch-img="${savedShade.swatchImg}"]`
              );
              if (matchingSwatch) {
                // Remove selected class from all swatches
                this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
                // Add selected class to saved swatch
                matchingSwatch.classList.add('vto-swatch-selected');

                // Check the radio input
                const radioInput = matchingSwatch.querySelector('input[type="radio"]');
                if (radioInput) {
                  radioInput.checked = true;
                }
                savedShade.available = !matchingSwatch.classList.contains('oos');
              } else {
                delete this.vto.wizard.selectedShades[this.vto.wizard.currentIndex];
                this.resetCurrentBadgeToNoSelection();
              }

              // Update badge to show saved selection
              if (matchingSwatch) {
                this.updateWizardBadge(this.vto.wizard.currentIndex, savedShade.swatchImg, savedShade.variantTitle);
              }
            }
          }
        }
      }

      // ========================================
      // End bundle wizard experience
      // ========================================

      // ========================================
      // Multi-product VTO experience
      // ========================================
      detectMultiProductContext(opener) {
        // Check if window data indicates multi-product VTO context (custom kit or other sources)
        const allowMultiProduct = window.__multiVtoMeta?.allowMultiProduct !== false;
        const hasProductData = Array.isArray(window.__multiVtoProducts) && window.__multiVtoProducts.length > 0;
        const hasMultiProductData = allowMultiProduct && hasProductData;

        if (hasMultiProductData) {
          this.vto.multiProduct.isMultiProduct = true;
          // Get products from window context set by custom-kit.js
          const newProducts = window.__multiVtoProducts && window.__multiVtoProducts.length > 0 ? window.__multiVtoProducts : [];
          const existingHandles = this.vto.multiProduct.products.map(product => product.handle).join(',');
          const newHandles = newProducts.map(product => product.handle).join(',');

          if (existingHandles !== newHandles) {
            this.vto.multiProduct.initialized = false;
          }
          this.vto.multiProduct.products = newProducts;

          this.vto.multiProduct.fromCustomKit = window.__multiVtoMeta?.fromCustomKit ?? false;
          this.vto.multiProduct.collectionId = Number(window.__multiVtoMeta?.collectionId) || null;
          // Ensure the multi-product container exists (created dynamically)
          this.ensureMultiProductContainer();
          this.updateMultiProductCta();
        } else {
          this.vto.multiProduct.isMultiProduct = false;
          this.vto.multiProduct.products = [];
          this.vto.multiProduct.currentIndex = 0;
          this.vto.multiProduct.initialized = false;
          this.vto.multiProduct.fromCustomKit = false;
          this.vto.multiProduct.collectionId = null;
          this.updateMultiProductCta();
          if (this.vto.multiProduct.swiper) {
            this.vto.multiProduct.swiper.destroy(true, true);
            this.vto.multiProduct.swiper = null;
          }
          if (this.vto.components.multiProductImages) {
            this.vto.components.multiProductImages.remove();
            this.vto.components.multiProductImages = null;
          }
        }
      }

      detectCustomKitSingleContext() {
        // Skip when multi-product VTO already owns the CTA
        if (this.vto.multiProduct.isMultiProduct) {
          this.vto.customKitSingleContext = null;
          return;
        }

        const customKitEl = document.querySelector('custom-kit');
        const openerProductId = Number(this.vto.openerProductId || this.vto.masterId);

        if (!customKitEl || !openerProductId) {
          this.vto.customKitSingleContext = null;
          this.updateMultiProductCta();
          return;
        }

        let collectionId = null;
        let productId = openerProductId;

        if (typeof customKitEl.findProductAndCollectionByProductId === 'function') {
          const { product, collection } = customKitEl.findProductAndCollectionByProductId(openerProductId) || {};
          if (product && collection) {
            collectionId = collection.id;
            productId = Number(product.id);
          }
        } else if (Array.isArray(customKitEl.collections)) {
          const collection = customKitEl.collections.find(col =>
            Array.isArray(col.products) && col.products.some(p => Number(p.id) === openerProductId)
          );
          if (collection) {
            collectionId = collection.id;
          }
        }

        this.vto.customKitSingleContext = collectionId
          ? { fromCustomKit: true, productId, collectionId: Number(collectionId) }
          : null;

        this.updateMultiProductCta();
      }

      initializeMultiProduct() {
        const container = this.vto.components.multiProductImages;
        if (!container || this.vto.multiProduct.products.length === 0) return;

        // Clear existing content and build swiper shell
        container.innerHTML = `
          <div class="swiper-wrapper"></div>
          <div class="vto-multi-product__swiper-button-prev"></div>
          <div class="vto-multi-product__swiper-button-next"></div>
        `;
        container.classList.add('has-products');

        const wrapper = container.querySelector('.swiper-wrapper');
        const prevButton = container.querySelector('.vto-multi-product__swiper-button-prev');
        const nextButton = container.querySelector('.vto-multi-product__swiper-button-next');

        // Render product images
        this.vto.multiProduct.products.forEach((product, index) => {
          const productImage = document.createElement('div');
          productImage.className = 'vto-multi-product__product-image swiper-slide';
          productImage.setAttribute('data-product-handle', product.handle);
          productImage.setAttribute('data-product-index', index);
          if (index === 0) {
            productImage.classList.add('active');
          }

          const img = document.createElement('img');
          img.src = product.featured_image;
          img.alt = product.title;
          img.loading = 'lazy';

          productImage.appendChild(img);
          wrapper.appendChild(productImage);

          // Add click handler to switch products
          productImage.addEventListener('click', () => this.handleMultiProductImageClick(index));
        });

        if (this.vto.multiProduct.swiper) {
          this.vto.multiProduct.swiper.destroy(true, true);
        }

        this.vto.multiProduct.swiper = new Swiper(container, {
          slidesPerView: 'auto',
          slidesPerGroup: 4,
          spaceBetween: 12,
          centeredSlides: false,
          centerInsufficientSlides: true,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton
          },
          on: {
            afterInit: (swiper) => this.toggleMultiProductNavigation(swiper),
            resize: (swiper) => this.toggleMultiProductNavigation(swiper),
            lock: (swiper) => this.toggleMultiProductNavigation(swiper),
            unlock: (swiper) => this.toggleMultiProductNavigation(swiper)
          }
        });

        // Determine which product to load first
        let initialIndex = 0;
        const targetProductId = window.__multiVtoMeta?.targetProductId;
        if (targetProductId) {
          const targetIndex = this.vto.multiProduct.products.findIndex(
            p => p.id === targetProductId || p.id === Number(targetProductId)
          );
          if (targetIndex !== -1) {
            initialIndex = targetIndex;
          }
        }

        // Load the target product (or first if no target)
        this.loadMultiProductAtIndex(initialIndex);
      }

      ensureMultiProductContainer() {
        if (this.vto.components.multiProductImages) return;

        const experiencesWrapper = this.querySelector('.vto-modal__all-experiences-inner-wrapper');
        const header = experiencesWrapper?.querySelector('.vto-modal__all-experiences-header');
        if (!experiencesWrapper || !header) return;

        const container = document.createElement('div');
        container.className = 'vto-multi-product__product-images swiper';
        container.innerHTML = `
          <div class="swiper-wrapper"></div>
          <div class="vto-multi-product__swiper-button-prev hidden"></div>
          <div class="vto-multi-product__swiper-button-next hidden"></div>
        `;

        experiencesWrapper.insertBefore(container, header);
        this.vto.components.multiProductImages = container;
      }

      handleMultiProductImageClick(index) {
        if (index === this.vto.multiProduct.currentIndex) return;
        this.vto.multiProduct.currentIndex = index;
        if (this.vto.multiProduct.swiper) {
          this.vto.multiProduct.swiper.slideTo(index);
        }
        this.loadMultiProductAtIndex(index);
      }

      loadMultiProductAtIndex(index) {
        const product = this.vto.multiProduct.products[index];
        if (!product) return;
        this.vto.multiProduct.currentIndex = index;

        if (this.vto.multiProduct.swiper) {
          this.vto.multiProduct.swiper.slideTo(index);
          this.toggleMultiProductNavigation(this.vto.multiProduct.swiper);
        }

        // Update active state on product images
        const images = this.vto.components.multiProductImages.querySelectorAll('.vto-multi-product__product-image');
        images.forEach((img, idx) => {
          if (idx === index) {
            img.classList.add('active');
          } else {
            img.classList.remove('active');
          }
        });

        // Update product title
        if (this.vto.components.productTitle) {
          this.vto.components.productTitle.textContent = product.title;
        }

        // Reset shade name
        if (this.vto.components.shadeName) {
          const defaultName = this.vto.components.shadeName.getAttribute('data-default-name');
          this.vto.components.shadeName.textContent = defaultName || 'Select a shade';
        }

        // Update modal data attributes
        this.setAttribute('data-masterid', product.id);
        this.setAttribute('data-handle', product.handle);
        this.setAttribute('data-vto-type', product.vto_type || 'Basic');

        // Update barcodes
        const barcodes = product.variants
          .filter(v => v.available)
          .map(v => v.barcode)
          .filter(b => b);
        this.setAttribute('data-variant-barcodes', `[${barcodes.join(',')}]`);

        // Update vto state
        this.vto.masterId = product.id;
        this.vto.state.experienceType = product.vto_type || 'Basic';

        // Update swatches
        this.updateMultiProductSwatches(product);

        // Ensure shade name and swatch visibility resets for each product
        this.vto.components.shadeName?.classList.remove('hidden');
        this.querySelector('.vto-modal__swatch-swiper-wrapper')?.classList.remove('hidden');

        // Single-variant product: auto-select and hide shade picker
        if (product.variants.length === 1 && product.variants[0].available !== false) {
          const singleSwatch = this.vto.components.swatchContainer.querySelector('.vto-modal__swatch');
          if (singleSwatch) {
            singleSwatch.click();
            this.vto.components.shadeName?.classList.add('hidden');
            this.querySelector('.vto-modal__swatch-swiper-wrapper')?.classList.add('hidden');
            this.updateMultiProductCta();
          }
          return;
        }

        // Check for saved user selection first, then fall back to default shade
        const savedSelection = this.vto.multiProduct.selectedShades[product.id];
        const targetVariantId = savedSelection?.variantId || product.default_variant_id;

        if (targetVariantId) {
          const targetSwatch = this.vto.components.swatchContainer?.querySelector(
            `[data-variant-id="${targetVariantId}"]`
          );
          if (targetSwatch) {
            // Restore carousel image if we have a saved variant image
            if (savedSelection?.variantImage) {
              this.updateMultiProductCarouselImage(product.id, savedSelection.variantImage);
            }

            // Programmatically click the swatch to trigger selection logic
            targetSwatch.click();
            this.updateMultiProductCta();

            // Scroll swatch carousel to show the selected shade
            const swatchSwiperEl = this.querySelector('.vto-modal__swatch-swiper');
            const swatchSwiper = swatchSwiperEl?.swiper;
            if (swatchSwiper) {
              const allSwatches = Array.from(this.vto.components.swatchContainer.querySelectorAll('.vto-modal__swatch'));
              const swatchIndex = allSwatches.indexOf(targetSwatch);
              if (swatchIndex >= 0) {
                swatchSwiper.slideTo(swatchIndex);
              }
            }
            return;
          }
        }

        // Reset CTA state when switching products (only if no selection was made)
        this.vto.components.vtoAddToBagButton?.removeAttribute('data-selected-variant-id');
        this.vto.components.vtoAddToBagButton?.removeAttribute('data-selected-variant-available');
        this.vto.components.vtoAddToBagButton.disabled = true;
        this.updateMultiProductCta();
      }

      toggleMultiProductNavigation(swiper) {
        if (!swiper || !swiper.navigation) return;

        const resolveEl = (el) => {
          if (!el) return null;
          if (Array.isArray(el)) return el[0];
          return el;
        };

        const prevEl = resolveEl(swiper.navigation.prevEl);
        const nextEl = resolveEl(swiper.navigation.nextEl);
        const shouldHideNav = swiper.isLocked || swiper.slides.length <= 1;

        [prevEl, nextEl].forEach((el) => {
          if (!el) return;
          if (shouldHideNav) {
            el.classList.add('hidden');
          } else {
            el.classList.remove('hidden');
          }
        });
      }

      updateMultiProductCarouselImage(productId, imageUrl) {
        if (!this.vto.components.multiProductImages || !imageUrl) return;

        const productIndex = this.vto.multiProduct.products.findIndex(p => p.id === productId);
        if (productIndex === -1) return;

        const productImageEl = this.vto.components.multiProductImages.querySelector(
          `[data-product-index="${productIndex}"] img`
        );
        if (productImageEl) {
          productImageEl.src = imageUrl;
        }
      }

      updateMultiProductSwatches(product) {
        if (!this.vto.components.swatchContainer) return;

        // Clear existing swatches
        this.vto.components.swatchContainer.innerHTML = '';

        product.variants.forEach((variant, index) => {
          const swatchDiv = document.createElement('div');
          swatchDiv.className = 'vto-modal__swatch swatch swiper-slide shade-variant';
          if (variant.available === false) {
            swatchDiv.classList.add('oos');
          }
          swatchDiv.setAttribute('data-variant-title', variant.title);
          swatchDiv.setAttribute('data-variant-barcode', variant.barcode || '');
          swatchDiv.setAttribute('data-variant-id', variant.id);
          if (variant.swatch_image) {
            swatchDiv.setAttribute('data-variant-swatch-img', variant.swatch_image);
          }

          const circleSwatchDiv = document.createElement('div');
          circleSwatchDiv.className = 'vto-modal__circle-swatch circle-swatch';

          const input = document.createElement('input');
          input.type = 'radio';
          input.id = `vto-modal__multi-swatch-${index}`;
          input.name = 'vto-swiper-swatch';
          input.value = variant.title;
          input.className = 'vto-shade-input';
          input.disabled = variant.available === false;

          const label = document.createElement('label');
          label.setAttribute('for', `vto-modal__multi-swatch-${index}`);

          const img = document.createElement('img');
          img.src = variant.swatch_image || '';
          img.alt = variant.title;
          img.title = variant.title;

          label.appendChild(img);
          circleSwatchDiv.appendChild(input);
          circleSwatchDiv.appendChild(label);
          swatchDiv.appendChild(circleSwatchDiv);

          this.vto.components.swatchContainer.appendChild(swatchDiv);
        });

        // Re-add event listeners to new swatches
        const newSwatches = this.vto.components.swatchContainer.querySelectorAll('.vto-modal__swatch');
        newSwatches.forEach(swatch => {
          swatch.addEventListener('click', this.handleSwatchClick.bind(this));
        });

        // Force Swiper to recalculate slide widths immediately so new slides don't
        // briefly render at their natural (unconstrained) size before the async observer fires.
        const swatchSwiperEl = this.querySelector('.vto-modal__swatch-swiper');
        swatchSwiperEl?.swiper?.update();

        // Update component references
        this.vto.components.swatches = this.querySelectorAll('.vto-modal__swatch');

        // Clear existing swatch selections and CTA state for new product
        this.vto.components.swatches.forEach(btn => btn.classList.remove('vto-swatch-selected'));
        this.vto.components.vtoAddToBagButton?.removeAttribute('data-selected-variant-id');
        this.vto.components.vtoAddToBagButton?.removeAttribute('data-selected-variant-available');
        this.vto.components.vtoAddToBagButton.disabled = true;
        this.updateMultiProductCta();
      }

      updateMultiProductCta() {
        const btn = this.vto.components.vtoAddToBagButton;
        if (!btn) return;

        const isCustomKitMulti = this.vto.multiProduct.isMultiProduct && this.vto.multiProduct.fromCustomKit;
        const isCustomKitSingle = !this.vto.multiProduct.isMultiProduct && this.vto.customKitSingleContext?.fromCustomKit;
        const isFromBuildKit = this.dataset.fromBuildKit === 'true';
        const isCustomKit = isCustomKitMulti || isCustomKitSingle || isFromBuildKit;

        if (!this.defaultCtaText) {
          this.defaultCtaText = btn.textContent?.trim() || this.defaultCtaText;
        }
        btn.textContent = isCustomKit ? 'ADD TO KIT' : this.defaultCtaText;
        btn.setAttribute('type', isCustomKit ? 'button' : 'submit');

        const hasVariant = !!btn.getAttribute('data-selected-variant-id');
        const isAvailable = btn.getAttribute('data-selected-variant-available') !== 'false';
        btn.disabled = !(hasVariant && isAvailable);
      }
      
      // ========================================
      // End multi-product VTO experience
      // ========================================

      waitForWindowProperty(prop, timeout = 10000) {
        return new Promise((resolve, reject) => {
          const interval = 50;
          let elapsed = 0;

          const check = () => {
            if (window[prop]) {
              resolve(window[prop]);
            } else if (elapsed >= timeout) {
              reject(new Error(`window.${prop} not found within ${timeout}ms`));
            } else {
              elapsed += interval;
              setTimeout(check, interval);
            }
          };

          check();
        });
      }
    }
  );
}
